export const NEXTGEN_HEADER_TOPBAR_HEIGHT = 120; //header bar + top bar
export const NEXTGEN_HEADER_TOPBAR_HEIGHT_SMALL = 96; // in small mode
export const NEXTGEN_RIGHTBAR_WIDTH = 84;
export const NEXTGEN_RIGHTBAR_HEIGHT = 35;
export const NEXTGEN_CANVAS_MARGIN_INSIDE = 30;
export const NEXTGEN_CANVAS_MARGIN_OUTSIDE = 25;
export const NEXTGEN_CANVAS_HORIZEN_MARGIN = 140;
export const NEXTGEN_CANVAS_MIN_WIDTH = 100;
export const NEXTGEN_CANVAS_MIN_HEIGHT = 70;
export const NEXTGEN_FLYOUT_WIDTH = 375;
export const SIDEBAR_ARROW_WIDTH = 15;
export const CANVAS_CONTENT_BORDER_RADIUS = 12;
export const CANVAS_RULER_AREA_WIDTH = 25;
export const CANVAS_AREA_MARGIN_TOP = 110;
export const CANVAS_AREA_MARGIN_TOP_SMALL = 90;
export const ZOOM_VIEW_SMALL_HEIGHT1 = 280;
export const ZOOM_VIEW_SMALL_HEIGHT2 = 230;
export const ZOOM_VIEW_SMALL_HEIGHT3 = 120;
export const LEFT_SIDEBAR_SMALL_HEIGHT1 = 570;
export const LEFT_SIDEBAR_SMALL_HEIGHT2 = 440;
export const LEFT_SIDEBAR_SMALL_HEIGHT3 = 250;
export const CANVAS_AREA_SMALL_HEIGHT = 620;
export const CANVAS_AREA_SMALL_WIDTH = 530;
export const DEFAULT_VIGNETTE_SIZE = 1000;
export const CANVAS_GET_STARTED_HEIGHT_31 = 164;
export const CANVAS_GET_STARTED_HEIGHT_32 = 194;
export const CANVAS_GET_STARTED_HEIGHT_41 = 224;
export const CANVAS_GET_STARTED_HEIGHT_42 = 254;
export const MAX_VIGNETTE_IMAGE_SIZE = 4000;
export const FLYOUT_MARGIN_TOP_SMALL = 110;
export const BOTTOM_SIDEBAR_HEIGHT = 60;
export const DISCLAIMER_HEIGHT = 80;
export const DISCLAIMER_WIDTH = 460;
export const DISCLAIMER_HEIGHT_SMALL_MODE = 64;
export const CANVAS_ROTATE_ICON_OFFSET = 10;
export const CANVAS_ROTATE_ICON_SIZE = 32;
export const CANVAS_CONTEXT_MENU_HEIGHT = 48;
export const ADDITIONAL_PRINT_SURFACE_CHARGE =
  'Designing an additional print surface will add {charge} to your subtotal.';
export const VIGNETTE_SIZE_PLACE_HOLDER = '_.-!SIZE!-._';
export const VIGNETTE_SCALE_PLACE_HOLDER = '_.-!SCALE!-._';

export const Scene7_Template_Prefix = '//images.promotionalstore.com/is/image/PromotionalStore/i?';

export const NEW_RECENT_OFFSET = 15;
export const SAVED_GRID_PAGESIZE = 6;
export const SAVED_GRID_COLUMNCOUNT = 2;
export const STOCK_GRID_PAGESIZE = 12;
export const STOCK_GRID_COLUMNCOUNT = 3;
export const RECENT_GRID_PAGESIZE = 6;
export const RECENT_GRID_COLUMNCOUNT = 2;
export const SLOGAN_GRID_PAGESIZE = 12;
export const SLOGAN_GRID_COLUMNCOUNT = 3;
export const VERSE_GRID_PAGESIZE = 6;
export const VERSE_GRID_COLUMNCOUNT = 2;
export const TEMPLATE_COUNT_PER_PAGE = 12;
export const CANVAS_ELEMENT_MIN_SIZE = 5;
export const CROP_GRIP_WIDTH = 18;
export const CROP_GRIP_HEIGHT = 6;
export const CANVAS_ELEMENT_BORDER_COLOR = '#3AA1BC';

export const nextgenBreakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1440,
  xl: 1742,
  xxl: 2032,
};

export const nextgenScreenMode = {
  extraSmall: 1,
  small: 2,
  middle: 3,
  large: 4,
  extraLarge: 5,
};

export const nextgenNodeId = {
  configuratorContainer: 'nextgen-configurator-container',
  canvasContent: 'nextgen-canvas-content',
  canvasContainer: 'nextgen-canvas-container',
  canvasProductImage: 'nextgen-canvas-product-image',
  leftSideBar: 'nextgen-leftsidebar',
  leftSideBarToolList: 'nextgen-leftsidebar-toollist',
  leftFlyoutContent: 'nextgen-leftFlyout-content',
  leftFlyoutContainer: 'nextgen-leftFlyout-container',
  flyoutPanelHeader: 'nextgen-flyoutPanel-header',
  toolbarContainer: 'toolbar-container-sm',
  flyoutWrapper: 'nextgen-flyout-wrapper',
  flyoutPanelContent: 'nextgen-flyoutPanel-content',
  nextgenNavbar: 'nextgen-navbar',
  sideBarProduct: 'LeftSideBarIcon-Product',
  sideBarText: 'LeftSideBarIcon-Text',
  sideBarUploads: 'LeftSideBarIcon-Uploads',
  sideBarGraphics: 'LeftSideBarIcon-Graphics',
  sideBarSlogan: 'LeftSideBarIcon-Slogan',
  sideBarVerse: 'LeftSideBarIcon-Verse',
  sideBarSentiment: 'LeftSideBarIcon-Sentiment',
  sideBarBackground: 'LeftSideBarIcon-Background',
  sideBarHelp: 'LeftSideBarIcon-Help',
  uploadPanelUploads: 'UploadPanelIconList-Uploads',
  uploadPanelRecent: 'UploadPanelIconList-Recent',
  getStartedAddText: 'GetStarted-Add Text',
  getStartedUploadArtwork: 'GetStarted-Upload Artwork',
  getStartedAddGraphics: 'GetStarted-Add Graphics',
  getStartedAddBackground: 'GetStarted-Add Background',
  getStartedInCanvasAddText: 'GetStarted-Add Tex-InCanvast',
  getStartedInCanvasUploadArtwork: 'GetStarted-Upload Artwork-InCanvas',
  getStartedInCanvasAddGraphics: 'GetStarted-Add Graphics-InCanvas',
  getStartedInCanvasAddBackground: 'GetStarted-Add Background-InCanvas',
  flyoutPanelOffcanvas: 'flyout-panel-offcanvas',
  nextgenUndo: 'nextgen-undo',
  nextgenRedo: 'nextgen-redo',
  nextgenZoom: 'nextgen-zoom',
  rotateHandlerId: 'nextgen-canvas-rotate-handler',
  rotateElementId: 'nextgen-canvas-rotate-element',
  textElementInputId: 'nextgen-text-element-input',
  canvasContextMenuContainer: 'nextgen-canvas-context-menu-container',
};

export const nextGenSidebarTabKeyEnum = {
  None: 100,
  GetStarted: 101,
  Product: 102,
  Text: 103,
  Uploads: 104,
  Graphics: 105,
  Background: 106,
  Slogan: 107,
  Verse: 108,
  Sentiment: 109,
  Help: 110,
};

export const sidebarTabIdMap = {};
sidebarTabIdMap[nextGenSidebarTabKeyEnum.Product] = nextgenNodeId.sideBarProduct;
sidebarTabIdMap[nextGenSidebarTabKeyEnum.Text] = nextgenNodeId.sideBarText;
sidebarTabIdMap[nextGenSidebarTabKeyEnum.Uploads] = nextgenNodeId.sideBarUploads;
sidebarTabIdMap[nextGenSidebarTabKeyEnum.Graphics] = nextgenNodeId.sideBarGraphics;
sidebarTabIdMap[nextGenSidebarTabKeyEnum.Background] = nextgenNodeId.sideBarBackground;
sidebarTabIdMap[nextGenSidebarTabKeyEnum.Slogan] = nextgenNodeId.sideBarSlogan;
sidebarTabIdMap[nextGenSidebarTabKeyEnum.Verse] = nextgenNodeId.sideBarVerse;
sidebarTabIdMap[nextGenSidebarTabKeyEnum.Sentiment] = nextgenNodeId.sideBarSentiment;
sidebarTabIdMap[nextGenSidebarTabKeyEnum.Help] = nextgenNodeId.sideBarHelp;

export const getStartedIconIdMap = {};
getStartedIconIdMap[nextGenSidebarTabKeyEnum.Text] = nextgenNodeId.getStartedAddText;
getStartedIconIdMap[nextGenSidebarTabKeyEnum.Uploads] = nextgenNodeId.getStartedUploadArtwork;
getStartedIconIdMap[nextGenSidebarTabKeyEnum.Graphics] = nextgenNodeId.getStartedAddGraphics;
getStartedIconIdMap[nextGenSidebarTabKeyEnum.Background] = nextgenNodeId.getStartedAddBackground;

export const getStartedInCanvasIconIdMap = {};
getStartedInCanvasIconIdMap[nextGenSidebarTabKeyEnum.Text] = nextgenNodeId.getStartedInCanvasAddText;
getStartedInCanvasIconIdMap[nextGenSidebarTabKeyEnum.Uploads] = nextgenNodeId.getStartedInCanvasUploadArtwork;
getStartedInCanvasIconIdMap[nextGenSidebarTabKeyEnum.Graphics] = nextgenNodeId.getStartedInCanvasAddGraphics;
getStartedInCanvasIconIdMap[nextGenSidebarTabKeyEnum.Background] = nextgenNodeId.getStartedInCanvasAddBackground;

export const nextGenFlyoutPanelEnum = {
  None: 120,
  GetStartedPanel: 121,
  UploadPanel: 122,
  EditUploadPanel: 123,
  GraphicPanel: 124,
  ProductPanel: 125,
  BackgroundPanel: 126,
  TextContainer: 127,
  LogoColorPickerPanel: 128,
  RecentPanel: 129,
  BackgroundRemoveWhitePanel: 130,
  BackgroundCropPanel: 131,
  BackgroundRotatePanel: 132,
  LogoRemoveWhitePanel: 133,
  LogoCropPanel: 134,
  LogoRotatePanel: 135,
  LogoColorPanel: 136,
  ScreenPrintedEditUploadPanel: 137,
  ScreenPrintedLogoColorPicker: 138,
  SloganPanel: 139,
  VersePanel: 140,
  SentimentPanel: 141,
  TextColorPanel: 142,
  EditImagePanel: 143,
  TextOutlineColorPanel: 144,
  TextFontPanel: 145,
  TextSymbolsPanel: 146,
  GraphicColorPanel: 147,
  AddTextPanel: 148,
  EditTextPanel: 149,
  EditBatchTextPanel: 150,
};

export const shareContentTypeEnum = {
  None: 0,
  Email: 1,
  EmailFeedback: 2,
  Print: 3,
};

export const shareContainerUITypeEnum = {
  Flyout: 0,
  Modal: 1,
};

export const flyoutTypes = {
  Left: 0,
  Bottom: 1,
  FullScreen: 2,
};

export const gestureDirectionEnum = {
  Left: 1,
  Right: 2,
  Up: 3,
  Down: 4,
  LeftOrRight: 5,
};

export const bottomFlyoutSizeEnum = {
  Large: 'full',
  Middle: 'middle',
  Small: 'small',
  Auto: 'auto',
  MaxHeightSmall: 'maxHeightSmall',
};

export const borderColorList = [
  { itemId: '47286', replacedColor: 'black' },
  { itemId: '41226', canvasKey: 'IMG315-PEN-41226', bomColor: '#606264', replacedColor: 'black' },
  { itemId: '41226', canvasKey: 'IMG315-PEN-41226', bomColor: '#BF2227', replacedColor: 'black' },
];

export const getStartedColorList = [
  { itemId: '47286', replacedColor: 'black' },
  { itemId: '41226', canvasKey: 'IMG315-PEN-41226', bomColor: '#606264', replacedColor: 'white' },
  { itemId: '41226', canvasKey: 'IMG315-PEN-41226', bomColor: '#BF2227', replacedColor: 'white' },
];

export const canvasContextMenuEnum = {
  Copy: 'Copy',
  Delete: 'Delete',
  Edit: 'Edit',
  Crop: 'Crop',
  CroppingCancel: 'CroppingCancel',
  CroppingApply: 'CroppingApply',
  CropReset: 'CropReset',
};

export const layeringType = {
  Up: 0,
  Down: 1,
};

export const flipTypes = {
  None: 0,
  Horizontal: 1,
  Vertical: 2,
  HorizontalVertical: 3,
};

export const artType = {
  Stock: 2,
  Recent: 3,
  Saved: 4,
  Slogan: 9,
  Verse: 12,
  Sentiment: 14,
};

export const artTitleEnum = {
  [artType.Stock]: 'Add Stock Art',
  [artType.Recent]: 'Recent Art',
  [artType.Saved]: 'Saved Art',
  [artType.Slogan]: 'Add Slogan',
  [artType.Verse]: 'Add Verse',
  [artType.Sentiment]: 'Add Sentiment',
};

export const boxGripEnum = {
  TopLeft: 0,
  TopRight: 1,
  BottomRight: 2,
  BottomLeft: 3,
  TopMiddle: 4,
  RightMiddle: 5,
  BottomMiddle: 6,
  LeftMiddle: 7,
  TopLeft2: 8,
  TopRight2: 9,
  BottomRight2: 10,
  BottomLeft2: 11,
};

export const zIndexOrder = {
  TransparencyCoverZindex: 120,
  ContextMenuZindexForCropping: 121,
};

export const applyStatusText = {
  Apply: 'Apply',
  Applying: 'Applying...',
  ApplyAgain: 'Apply Again',
};

export const confirmDialogContentType = {
  None: 0,
  ArtworkColorChanges: 1,
};

export const screenprintedFlyoutPanelChain = [
  [nextGenFlyoutPanelEnum.AddTextPanel, nextGenFlyoutPanelEnum.EditTextPanel, nextGenFlyoutPanelEnum.TextFontPanel],
  [
    nextGenFlyoutPanelEnum.AddTextPanel,
    nextGenFlyoutPanelEnum.EditBatchTextPanel,
    nextGenFlyoutPanelEnum.TextFontPanel,
  ],
  [nextGenFlyoutPanelEnum.AddTextPanel, nextGenFlyoutPanelEnum.EditTextPanel, nextGenFlyoutPanelEnum.TextSymbolsPanel],
  [nextGenFlyoutPanelEnum.AddTextPanel, nextGenFlyoutPanelEnum.EditTextPanel, nextGenFlyoutPanelEnum.TextColorPanel],
  [
    nextGenFlyoutPanelEnum.AddTextPanel,
    nextGenFlyoutPanelEnum.EditBatchTextPanel,
    nextGenFlyoutPanelEnum.TextColorPanel,
  ],
  [
    nextGenFlyoutPanelEnum.UploadPanel,
    nextGenFlyoutPanelEnum.EditImagePanel,
    nextGenFlyoutPanelEnum.ScreenPrintedLogoColorPicker,
  ],
];

export const digitalFlyoutPanelChain = [
  [nextGenFlyoutPanelEnum.AddTextPanel, nextGenFlyoutPanelEnum.EditTextPanel, nextGenFlyoutPanelEnum.TextFontPanel],
  [
    nextGenFlyoutPanelEnum.AddTextPanel,
    nextGenFlyoutPanelEnum.EditBatchTextPanel,
    nextGenFlyoutPanelEnum.TextFontPanel,
  ],
  [nextGenFlyoutPanelEnum.AddTextPanel, nextGenFlyoutPanelEnum.EditTextPanel, nextGenFlyoutPanelEnum.TextSymbolsPanel],
  [nextGenFlyoutPanelEnum.AddTextPanel, nextGenFlyoutPanelEnum.EditTextPanel, nextGenFlyoutPanelEnum.TextColorPanel],
  [
    nextGenFlyoutPanelEnum.AddTextPanel,
    nextGenFlyoutPanelEnum.EditBatchTextPanel,
    nextGenFlyoutPanelEnum.TextColorPanel,
  ],
  [
    nextGenFlyoutPanelEnum.AddTextPanel,
    nextGenFlyoutPanelEnum.EditTextPanel,
    nextGenFlyoutPanelEnum.TextOutlineColorPanel,
  ],
  [
    nextGenFlyoutPanelEnum.UploadPanel,
    nextGenFlyoutPanelEnum.EditImagePanel,
    nextGenFlyoutPanelEnum.LogoColorPickerPanel,
  ],
];

export const validateImprintRequiredResult = {
  Valid: 1,
  Confirm: 0,
  GroupError: -1,
  ItemError: -2,
};
